 const RecalculationRoutesGraphQL = {
    NO: 'No',
    ONLY_ETA: 'OnlyETA',
    ORDER_AND_ETA: 'OrderAndETA',
};

export default RecalculationRoutesGraphQL;
